let isLogoutInProgress = false;

const forceLogout = (reason) => {
  if (isLogoutInProgress) return;
  if (window.location.pathname === "/logout") return;

  localStorage.setItem("logoutReason", reason || "SESSION_REQUIRES_RELOGIN");

  isLogoutInProgress = true;
  window.location.assign("/logout");
};

export default forceLogout;